import '@updater-components/icon';
import template from './renters-insurance.html';
import { ITEM_KINDS, ITEM_DEFINITION_CODES } from '../../../constants';
import { selectors } from '../../../state';
import './renters-insurance.global.css';
import { trackEngagement } from '@mover-app/engagement';

const HEADER_TEXT = {
  REQUIRED: {
    HEADER: 'Renters Insurance Is Required Prior To Move-In',
    SUB_HEADER:
      'You are required to purchase a renters insurance policy prior to moving into your new home.',
  },
  NOT_REQUIRED: {
    HEADER: 'Secure Renters Insurance Before Moving In',
    SUB_HEADER: `It's recommended to purchase a renters insurance policy prior to moving into your new home.`,
  },
};

export class RentersInsuranceController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
    trackEngagement({
      name: "Renter's Insurance",
      code: ITEM_DEFINITION_CODES.RENTERS_INSURANCE,
    });
  }

  $onDestroy() {
    this.disconnect();
  }

  get hasRequirements() {
    return !!this.page.requirements.length;
  }

  get stepHeader() {
    return this.page.required ? HEADER_TEXT.REQUIRED : HEADER_TEXT.NOT_REQUIRED;
  }
}

export const RentersInsuranceComponent = {
  template,
  controller: RentersInsuranceController,
};

function buildAnalytics(page) {
  return {
    eventName: 'Clicked Renters Insurance CTA',
    properties: {
      'Insurance Company Name': page.name,
    },
  };
}

function mapStateToThis(state) {
  const {
    companyDisplayName,
    companyName,
    hasDivision,
    divisionName,
  } = selectors.current.siteConfig();
  const itemDefinition = selectors.itemDefinition.byCode(
    ITEM_KINDS.RENTERS_INSURANCE
  );
  const page = itemDefinition.page(state) || {};

  const recommender = hasDivision(state)
    ? divisionName(state)
    : companyDisplayName(state) || companyName(state);

  return {
    page,
    ctaAnalytics: buildAnalytics(page),
    recommender,
  };
}
